import { Platform } from '../../services/helpers/platform';

function waitTransition(element)
{
  return new Promise(resolve => {
    element.ontransitionend = function(e) {
      element.ontransitionend = null;
      resolve();
    }
  });
}

class WindowMessage
{
  //
  static init()
  {
    document.querySelectorAll(".window-container")
    .forEach((item) => {
      const matched = item.dataset.os
        .split(",")
        .includes(Platform.os);
      
      if (!matched)
      {
        item.parentNode.removeChild(item);
      }
      else
      {
        item.classList.remove("window-hidden");

        new WindowMessage(item)
        .enable()
        .listenButtons();
      }
    });
  }

  //
  constructor(element, config = {})
  {
    this.container = element;
    this.id = this.container.dataset.id;
    this.parentId = this.container.dataset.parentId;
    this.config = config;
  }

  //
  enable()
  {
    this.container.classList.remove("hidden");
    this.logAppear();

    return this;
  }

  //
  close()
  {
    const height = this.container.getBoundingClientRect().height;

    this.container.style.maxHeight = height + "px";
    this.container.classList.add("closed");

    setTimeout(() =>
    {
      this.container.style.maxHeight = 0;
    }, 0);

    waitTransition(this.container)
    .then(() => this.container.parentNode.removeChild(this.container));

    return this;
  }

  //
  listenButtons()
  {
    this.container.querySelectorAll("[data-btn-id]")
    .forEach(button => this.listenButton(button));

    return this;
  }

  //
  listenButton(button)
  {
    const $this = this;

    button.addEventListener("click", function lstn() {
      this.removeEventListener("click", lstn);

      $this.logButton(button.dataset.btnId);
    });
  }

  //
  logButton(buttonId)
  {
    const data = new FormData();

    data.append("logs[0][id]", buttonId);
    data.append("logs[0][type]", "click");
    data.append("logs[0][time]", performance.now());
    data.append("logs[0][url]", window.location.href);

    fetch("/api/scenario/log", {
      method: "POST",
      body: data
    })
    .catch(e => 0);

    this.seen();

    return this.close();
  }

  //
  logAppear()
  {
    fetch(`/api/scenario/${this.id}/updateViews`, {
      method: "POST"
    })
    .catch(e => 0);
  }

  //
  seen()
  {
    const maxAge = 60 * 60 * 24 * 30;
    const name = "seenWindow_" + this.parentId;

    document.cookie = `${name}=${name}; path=/; max-age=${maxAge}`;

    return this;
  }
}

export { WindowMessage };
